import { Badge } from '@mantine/core';

type CandidateResumeStatusBadgeProps = {
  isActive: boolean;
};

const RESUME_STATUS_PRESENTATION = {
  active: {
    backgroundColor: '#3ECB4C29',
    color: 'var(--mantine-color-green-4)',
    label: 'Активный',
  },
  inactive: {
    backgroundColor: '#A9A9AB29',
    color: 'var(--mantine-color-tertiary-7)',
    label: 'Неактивный',
  },
} as const;

export const CandidateResumeStatusBadge = ({
  isActive,
}: CandidateResumeStatusBadgeProps) => {
  const presentation =
    RESUME_STATUS_PRESENTATION[isActive ? 'active' : 'inactive'];

  return (
    <Badge
      size='xs'
      styles={{
        root: { backgroundColor: presentation.backgroundColor },
        label: { color: presentation.color },
      }}
    >
      {presentation.label}
    </Badge>
  );
};
